import { z } from 'zod';
import validations from 'utils/validations';

export const schema = z.object({
  permissions: z.array(z.any()).min(1, 'You must select at least one permission'),
  description: validations.requiredString('Description is required'),
});
